import {
  Avatar,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Modal } from '../../../../components';
import ActionsList from '../../../../components/ActionsList';
import LoadingComponent from '../../../../components/Loading';
import { MORADO_COLOR } from '../../../../constants/ColorsConst';
import { SU } from '../../../../constants/ConfigConst';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, getNameFromUserCode } from '../../../../helpers';
import { useNotification } from '../../../../helpers/notification';
import { textLabelsTable } from '../../../invitados/components/ListadoInvitados';
import { isManagerUserCode } from '../../../modulos/modules.helpers';
import { NameComponent } from '../../../usuarios/components/ListadoUsuarios';
import {
  deleteReservacionesClasesAction,
  saveReservacionesClasesAction,
} from '../ReservacionesClasesAction';
import AlertDialog from '../../../../components/AlertDialog';
import { deleteClasesDocentesAction, setActivoClasesDocentesAction } from '../../clases_docentes/ClasesDocentesAction';

const ListadoClasesProfesores = ({
  setOpenModalForm,
  params = {},
  handleSelectTeacher = () => {},
  handleEditTeacher = () => {},
}) => {
  const dispatch = Redux.useDispatch();
  const { addNotification } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const clasesDocentesStore = Redux.useSelector(
    (state) => state.clasesDocentes
  );
  const clasesStore = Redux.useSelector((state) => state.clases);
  const loginStore = Redux.useSelector((state) => state.login);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  const isRoot = loginStore.user.roles.some((r) => r.name === SU);
  const isManager =
    !isRoot &&
    isManagerUserCode(loginStore.user.userCodes, entidadesStore.activo?.id);

  const [rows, setRows] = React.useState([]);
  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isToggleActive, setIsToggleActive] = React.useState(false);

  React.useEffect(() => {
    setRows([]);
    clasesDocentesStore.all.forEach((el) => {
      setRows((old) => [
        ...old,
        {
          ...el,
          avatar: el.userCode.avatar,
          name: getNameFromUserCode(el.userCode),
          documentId: `${el.userCode.user.profile.typeDocument}-${el.userCode.user.profile.identificationNumber}`,
          startDate: dateformat(el.startDate, {}),
          endDate: dateformat(el.endDate, {}),
          actions: el,
        },
      ]);
    });
  }, [clasesDocentesStore.all]);

  const _handleDeleteClick = async (id) => {
    setLoadingDelete(true);
    await deleteClasesDocentesAction(
      { dispatch, addNotification },
      id,
      { ...params, classId: clasesStore.activo.id }
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const _handleToggleActiveClick = async (id) => {
    setLoadingDelete(true);
    await saveReservacionesClasesAction(
      { dispatch, addNotification },
      entidadesStore.activo.id,
      id,
      {
        active: !clasesDocentesStore.activo.active,
      }
    );
    setIsToggleActive(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: 'excluded',
        filter: false,
      },
    },
    {
      name: 'userCode',
      label: 'Profesor',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => {
                const data = clasesDocentesStore.all.find(
                  (cd) => cd.id === tableMeta.rowData[0]
                );
                handleSelectTeacher(data.id);
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px',
                }}
              >
                <div>
                  <Avatar
                    alt={value.avatar}
                    sx={{ width: 30, height: 30 }}
                    src={value.avatar}
                  />
                </div>
                <div style={{ marginLeft: '10px' }}>
                  <NameComponent>
                    {getNameFromUserCode(value, { code: true })}
                  </NameComponent>
                  <NameComponent>
                    CI:{' '}
                    {`${value.user.profile.typeDocument}-${value.user.profile.identificationNumber}`}
                  </NameComponent>
                </div>
              </div>
            </NameComponent>
          );
        },
      },
    },
    {
      name: 'startDate',
      label: 'Fecha de inicio',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'endDate',
      label: 'Fecha de finalización',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'numberSpots',
      label: 'Puestos',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.ACTIONS,
      label: 'Acción',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box align="left" sx={{ width: '5em' }}>
              <ActionsList
                id={tableMeta.rowData[0]}
                onDelete={async () => {
                  await setActivoClasesDocentesAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
                onEdit={async () => {
                  handleEditTeacher(value.id);
                }}
                active={value.active}
              />
            </Box>
          );
        },
      },
    },
  ];

  if (isManager) {
    columns.pop();
  }

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    onSearchChange: (text) => {
      console.log('buscardor', text);
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels: textLabelsTable,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    selectableRowsHideCheckboxes: true,
  };

  return (
    <Grid container>
      <LoadingComponent
        isLoading={clasesDocentesStore.loadingGetAll || loadingDelete}
        text="Cargando lista..."
      />
      <Grid item md={12}>
        <MUIDataTable data={rows} columns={columns} options={options} />
      </Grid>
      {clasesDocentesStore.activo ? (
        <Modal
          id="modalFormReservacionesClases"
          title={`Eliminar`}
          open={isDelete}
          maxWidth="sm"
          onClose={() => setIsDelete(!isDelete)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              ¿Seguro que quieres eliminar este tipo de documento?
              <p>
                <strong>{clasesDocentesStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleDeleteClick(clasesDocentesStore.activo.id);
              }}
            >
              ELIMINAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsDelete(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}

      {clasesDocentesStore.activo ? (
        <Modal
          id="modalToggleActivo"
          title={`${
            clasesDocentesStore.activo.active ? 'Bloquear' : 'Activar'
          } ${clasesDocentesStore.activo.name}`}
          open={isToggleActive}
          maxWidth="sm"
          onClose={() => setIsToggleActive(!isToggleActive)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`¿Seguro que quieres ${
                clasesDocentesStore.activo.active ? 'Bloquear' : 'Activar'
              } este tipo de documento?`}
              <p>
                <strong>{clasesDocentesStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleToggleActiveClick(clasesDocentesStore.activo.id);
              }}
            >
              ACEPTAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsToggleActive(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      ) : null}
      {openModalDelete && (
        <AlertDialog
          open={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onAccept={async () => {
            await _handleDeleteClick(clasesDocentesStore.activo.id);
          }}
          title="Eliminar profesor"
          description="¿Estás seguro de querer eliminar el profesor?"
        />
      )}
    </Grid>
  );
};

export default ListadoClasesProfesores;
